let _ = require("lodash");

const _items = [];

const add = (item)=>{
    _items.push(item);
}

const remove = (item)=>{
    _.remove(_items,(t)=> t===item);
}

const getItems = (appName)=>{   //找出与指定应用有关的菜单配置
    return _.filter(_items,(t)=>{
        return t.position?.app===appName;
    });
}


export {
    add,
    remove,
    getItems
}